/**
 * Usa la función de la librería fetchJsonp para poder evitar el problema de cors
 * En la respuesta hace la llamada a la función "handleResponse" para poder manipular los datos
 */

import fetchJsonp from 'fetch-jsonp'
import { DICTIONARY_CONFIG } from '../config'
import { handleResponse } from './handleResponse'
import sha1 from 'sha1'
import { cleanUrlForHash } from './cleanUrlForHash'

import { isModal } from '../helpers/actionsDependingURL'

const { dictionaryName, idTag, serviceName } = DICTIONARY_CONFIG

const generateHash = () => sha1(cleanUrlForHash())

export const urlToDictionaryCall = `${serviceName}${idTag}${dictionaryName}${generateHash()}`

export function dictionaryResponse() {
  fetchJsonp(urlToDictionaryCall)
    .then((res) => res.json())
    .then((data) => {
      if (!data || !data.value) {
        console.warn(
          `URL no contemplada en el diccionario, asignando comportamiento de modal.`
        );
        isModal();
        return;
      }
      handleResponse(data);
    })
    .catch((error) => {
      console.warn(
        `Ha ocurrido un error en la llamada: ${error}, asignando comportamiento de modal.`
      );
      isModal();
      
    });
}

